"use client";

// Fehlerzustand des Bereichs: ein Satz, ein Knopf. Die technische
// Meldung bleibt auf dem Server (Next ersetzt sie im Produktionsbau).
import { useEffect } from "react";
import { TriangleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";

export default function NachrichtenFehler({ error, retry }: { error: unknown; retry: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);
  const digest = error instanceof Error ? (error as Error & { digest?: string }).digest : undefined;

  return (
    <EmptyState
      icon={TriangleAlert}
      title="Die Nachrichten ließen sich nicht laden"
      description={digest ? `Fehlerkennung ${digest} — bitte bei der Ansichtssache melden, wenn es bleibt.` : "Bitte noch einmal versuchen."}
      action={<Button onClick={() => retry()}>Noch einmal</Button>}
    />
  );
}
